import { z } from 'my-zod'
import { AdditionalCustomerOrderQuestionType } from '../additional-customer-order-question'

export const additionalQuestionResponse = z
  .object({
    questionId: z.number(),
    questionType: AdditionalCustomerOrderQuestionType,
    prompt: z.string(),
    description: z.string(),
    answer: z.string().max(64, `Text shouldn't be longer than 64 characters`).or(z.boolean()).nullish()
  })
  .superRefine((val, ctx) => {
    if (val.questionType === 'checkboxRequired' || val.questionType === 'textRequired') {
      if (!val.answer) {
        ctx.addIssue({
          code: 'custom',
          message: 'Required',
          path: ['answer']
        })
      }
    }
  })

export type AdditionalQuestionResponse = z.infer<typeof additionalQuestionResponse>
